function cleanInput(value, decimals = null) {
    value = value.trim();
    value =
        value.includes(',') && value.includes('.')
            ? value.replace(/[^\d.]/gu, '')
            : value.replace(/[^\d,.]/gu, '');
    value = value.replace(/,+/gu, '.');
    if (value === '.')
        value = '0.';
    value = value.split('.').slice(0, 2).join('.');
    if (value.startsWith('0')) {
        value = value.replace(/^0+/u, '');
        if (value === '' || value.startsWith('.'))
            value = `0${value}`;
    }
    if (decimals !== null && value.includes('.')) {
        let [first, last] = value.split('.');
        if (decimals === 0)
            return first;
        last = last.slice(0, decimals);
        value = [first, last].join('.');
    }
    return value;
}
export default cleanInput;
